import { createZustandStore } from '../createZustandStore';
import type {
  IAlertSlice,
  IUpdateSingleBillSlice,
  ISingleBillInfoFormSlice,
  ISingleBillPaymentMethodsSlice,
  IUpdateBillingSlice,
} from '../slices';
import {
  createAlertSlice,
  createUpdateSingleBillSlice,
  createSingleBillInfoFormSlice,
  createSingleBillPaymentMethodsSlice,
} from '../slices';

export type ISingleBillPageStore = IUpdateSingleBillSlice &
  ISingleBillInfoFormSlice &
  ISingleBillPaymentMethodsSlice &
  IUpdateBillingSlice &
  IAlertSlice;

export const useSingleBillPageStore = createZustandStore(
  createUpdateSingleBillSlice,
  createSingleBillInfoFormSlice,
  createSingleBillPaymentMethodsSlice,
  createAlertSlice
);
